import { VoyageDialogPopupBodyWarning } from "../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-body-warning";
import { VoyageDialogPopupManager } from "../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-manager";
import { SvgIcons } from "../../local_modules/voyage-svg-icons/src/voyage-svg-icons";

export function verifyProtocol()
{
    if (window.location.protocol === 'file:')
    {
        const imoNumber = (<any>window)["appenv"].vesselIMONumber;
        
        const warningElement = new VoyageDialogPopupBodyWarning;
        warningElement.icon = SvgIcons.lightExclamationCircle;
        warningElement.warningSummary = "It seems you have opened the application from an invalid URL on your local computer.";
        warningElement.warningDescription = `Please access application by opening the Chrome Browser on your computer and open the \n link http://${imoNumber}cvfab01/voyage/`;
        warningElement.descriptionTextAlign = "center";

     

        VoyageDialogPopupManager.createDialog({
            headerText: "Invalid URL",
            bodyContent: warningElement,
            noCloseButton: true,
            noAcceptButton: true
        });
    }
}